module.exports = __webpack_public_path__ + "img/success.daee5c13.svg";